import { useEffect, useState } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';

const links = [
  { to: '/services', label: 'Services' },
  { to: '/methodology', label: 'Methodology' },
  { to: '/introductions', label: 'Introductions' },
  { to: '/library', label: 'Library' },
  { to: '/blog', label: 'Blog' },
  { to: '/about', label: 'About' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  // Introductions visitors book the 20-minute intro call, never the AI
  // Diagnostic funnel at /book.
  const { pathname } = useLocation();
  const bookTo = pathname.startsWith('/introductions') ? '/introductions/book' : '/book';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed left-1/2 top-4 z-50 -translate-x-1/2 transition-all duration-500 ${
        scrolled ? 'w-[min(96%,860px)]' : 'w-[min(96%,1080px)]'
      }`}
    >
      <div
        className={`grain flex items-center justify-between gap-6 rounded-full border px-5 py-3 backdrop-blur-md transition-all duration-500 ${
          scrolled ? 'border-gold/30 bg-black/70' : 'border-white/10 bg-black/40'
        }`}
      >
        <Link to="/" className="flex items-center">
          <img src="/logo.png" alt="Samia Systems" className="h-10 w-auto" />
        </Link>

        <nav className="hidden items-center gap-4 md:flex lg:gap-7">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              className={({ isActive }) =>
                `font-sans text-[0.72rem] uppercase tracking-label transition-colors ${
                  isActive ? 'text-gold' : 'text-white/85 hover:text-white'
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <Link
          to={bookTo}
          className="group hidden items-center gap-2 whitespace-nowrap rounded-full border border-gold/60 px-4 py-1.5 font-sans text-[0.7rem] uppercase tracking-label text-white transition hover:bg-gold hover:text-black md:inline-flex"
        >
          Book <span className="text-gold transition-colors group-hover:text-white">→</span>
        </Link>

        <button
          aria-label={open ? 'Close menu' : 'Open menu'}
          aria-expanded={open}
          aria-controls="mobile-nav"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden"
        >
          <span className="block h-px w-6 bg-white" />
          <span className="mt-1.5 block h-px w-6 bg-white" />
          <span className="mt-1.5 block h-px w-4 bg-gold" />
        </button>
      </div>

      {open && (
        <div id="mobile-nav" className="mt-2 rounded-3xl border border-white/10 bg-black/90 p-6 backdrop-blur-md md:hidden">
          <ul className="flex flex-col gap-4">
            {links.map((l) => (
              <li key={l.to}>
                <NavLink
                  to={l.to}
                  onClick={() => setOpen(false)}
                  className="font-sans text-sm uppercase tracking-label text-white/90"
                >
                  {l.label}
                </NavLink>
              </li>
            ))}
            <li>
              <NavLink
                to={bookTo}
                onClick={() => setOpen(false)}
                className="font-sans text-sm uppercase tracking-label text-gold"
              >
                Book →
              </NavLink>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}
